import ChatMessagesColumn from '@/components/chat/ChatMessagesColumn.vue';
import SideModal from '@/components/modals/SideModal';
import socket from '@corefront/utils/socket';
import { MESSAGE_CATEGORY as CATEGORY, MESSAGE_ROLES as ROLES, MESSAGE_TYPES as TYPES } from '@/constants/message';
import { EVENTS } from '@corefront/constant/socket';
import { mapState } from 'vuex';
import { chatThread } from '@corefront/mixins-v2/chatThread';
export default {
  components: {
    SideModal,
    ChatMessagesColumn
  },
  mixins: [chatThread],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    conversationId: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedCategory: CATEGORY.ALL,
      onlineStatusResponse: null,
      showMessages: false,
      readOnly: false
    };
  },
  computed: {
    ...mapState('chat', ['statesAPC', 'selectedConversation']),
    ...mapState('patients', ['patient']),
    isShow: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.init();
        }
      },
      immediate: true
    },
    conversationId(newVal, oldVal) {
      if (newVal && newVal !== oldVal && this.value) {
        this.init();
      }
    }
  },
  mounted() {
    this.listenToSocketEvents();
  },
  methods: {
    async init() {
      // clear chat state
      this.$store.commit('chat/SET_STATE', {
        conversations: [],
        messages: [],
        selectedConversation: null
      });
      this.showMessages = false;
      this.readOnly = !this.statesAPC.includes(this.patient.state);
      this.$store.commit('chat/SET_SELECTED_CONVERSATION', {
        id: this.conversationId,
        patient: this.patient
      });
      if (this.conversationId) {
        await Promise.all([this.$store.dispatch('chat/getConversationAssignee', this.conversationId), this.$store.dispatch('chat/fetchDoctorPatientMessages', {
          conversationid: this.conversationId
        })]);
      }
      this.showMessages = true;
      await this.$nextTick();
      await this.$_chatThread_scrollToBottom();
    },
    async listenToSocketEvents() {
      await socket.waitUntilReady();
      socket.ctx.on(EVENTS.ADMIN_CHAT_MESSAGE, message => {
        if (message.conversationId === this.patient.id) {
          this.$store.commit('chat/APPEND_MESSAGE', {
            type: message.type,
            id: message.id,
            data: {
              ...message,
              ...(message.senderRole === ROLES.PATIENT ? {
                patient: message.sender
              } : {
                admin: message.sender
              })
            }
          });
        } else {
          this.$store.dispatch('chat/fetchConversations', {
            type: this.selectedCategory === CATEGORY.ALL ? null : this.selectedCategory
          });
          this.$store.dispatch('chat/getMetrics');
        }
      });
      socket.ctx.on(EVENTS.PATIENT_NOTE_ADDED, note => {
        if (note.patientId === this.patient.id) {
          this.$store.dispatch('chat/appendMessage', {
            type: TYPES.NOTE,
            id: note.id,
            data: {
              ...note,
              type: TYPES.NOTE
            }
          });
        }
      });
      socket.ctx.on(EVENTS.ADMIN_CHAT_ASSIGNMENT_CHANGED, data => {
        if (!data.from && this.selectedCategory === CATEGORY.UNASSIGNED) {
          this.$store.commit('chat/REMOVE_CONVERSATION', data.patientId);
        }
      });
      socket.ctx.on(EVENTS.ADMIN_CHAT_CONVERSATION_DISMISSED, data => {
        this.$store.commit('chat/REMOVE_CONVERSATION', data.patientId);
      });
      socket.ctx.on(EVENTS.ADMIN_CHAT_CONVERSATION_REOPENED, data => {
        this.$store.commit('chat/REMOVE_CONVERSATION', data.patientId);
      });
      socket.ctx.on(EVENTS.ONLINE_STATUS, data => {
        this.onlineStatusResponse = data;
        this.$store.dispatch('chat/updateOnlineStatus', data);
      });
    }
  }
};